import { createClient } from '@/shared/api';
import type { StartStreamEcgMutation, StartStreamEcgMutationVariables } from '@/shared/api';
import START_STREAM_ECG_MUTATION from '../mutations/startStreamECG';

/**
 * Starts a live ECG streaming session for a study. Runs START_STREAM_ECG_MUTATION and throws the returned message when isSuccess is false.
 *
 * @param input - Mutation input payload.
 * @returns A promise resolving once the mutation result has been checked for success.
 */
const handleStartStreamECG = async (
  input: StartStreamEcgMutationVariables['input'],
): Promise<void> => {
  const client = createClient();
  const result = await client.mutate<StartStreamEcgMutation, StartStreamEcgMutationVariables>({
    mutation: START_STREAM_ECG_MUTATION,
    variables: {
      input,
    },
  });
  const { data } = result;
  const { startStreamECG } = data ?? {};
  const { isSuccess, message } = startStreamECG ?? {};
  if (!isSuccess) {
    throw new Error(message ?? undefined);
  }
};

export default handleStartStreamECG;
